"use strict";

require('./CompanyPublicationService.js');

function PublicationTypeaheadDirective(CompanyPublicationService, growl, $translate) {
  return {
    restrict: "EA",
    templateUrl: "partials/company/publications/publication-typeahead.html",
    scope: {
      company:       "=pCompany",
      target:        "=pTarget",
      publications:  "=pCurrent",
      appFormSubmit: "=?appFormSubmit"
    },
    link: function($scope, element) {
      $scope.addPublication = function(publication) {
        if (!$scope.appFormSubmit) {
          publication.groups.push($scope.target);

          CompanyPublicationService.update({
            companyId: $scope.company,
            publicationId: publication.id
          }, publication).$promise.then(function() {

            $scope.publications.unshift(publication);
            $scope.addNewPublication = {};

            growl.addSuccessMessage($translate.instant('publication.add-success'));
            $scope.addNewPublication.addedPublication = "";

          }, function() {
            growl.addErrorMessage($translate.instant('publication.add-failure'));
          });
        } else {
          $scope.appFormSubmit.publicationIds.push(publication.id);
          $scope.appFormSubmit.$update({
            companyId: $scope.company,
            groupId: $scope.appFormSubmit.id
          },function(){
            $scope.publications.unshift(publication);
            growl.addSuccessMessage($translate.instant('publication.add-success'));
            $scope.addNewPublication.addedPublication = "";
          }, function(resp){
            if (resp.status && resp.status === 304 ) {
              growl.addErrorMessage($translate.instant('publication.reached-your-limit'));
            } else {
              growl.addErrorMessage($translate.instant('publication.add-failure'));
            }
            
          });
        }
      };

      $scope.queryPublications = function(text) {
        var filter = {
          companyId: $scope.company,
          q:         text,
          limit:     10
        };
      
        if ($scope.appFormSubmit) {
          filter.type = 'FORM';
        }
        return CompanyPublicationService.query(filter).$promise.then(function(p) {
          return p.filter(function(p) {
            return !$scope.publications.some(function(publication) {
              return publication.id === p.id;
            });
          });
        });
      };

      element.find('input[type="text"]').bind("keydown keypress", function (event) {
        if(event.which === 13) {
          $scope.$apply(function (){
            $scope.addPublication($scope.addNewPublication.addedPublication);
          });
          event.preventDefault();
        }
      });
    }
  };
}


angular.module("dokiv")
  .directive("pTypeahead", [
    'CompanyPublicationService',
    'growl',
    '$translate',
    PublicationTypeaheadDirective
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/PublicationTypeaheadDirective.js
// module id = 29
// module chunks = 0